import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "aurea_cart_v1";
const WISH_KEY = "aurea_wishlist_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]").map((i) => ({ ...i, key: i.key || i.product_id })); } catch { return []; }
  });
  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem(WISH_KEY, JSON.stringify(wishlist)); }, [wishlist]);

  const add = (product, qty = 1, variant = null) => {
    const key = variant ? `${product.id}::${variant.name}` : product.id;
    setItems((prev) => {
      if (prev.some((i) => i.key === key)) {
        return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, { key, product_id: product.id, name: product.name, price: product.price, image: variant?.image || product.image, quantity: qty, color: variant?.name || null, color_hex: variant?.hex || null }];
    });
    toast.success(`${product.name}${variant ? ` (${variant.name})` : ""} added to cart`);
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const updateQty = (key, quantity) => setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, quantity) } : i));
  const clear = () => setItems([]);

  const toggleWish = (product) => {
    setWishlist((prev) => {
      const exists = prev.find((p) => p.id === product.id);
      if (exists) { toast(`Removed from wishlist`); return prev.filter((p) => p.id !== product.id); }
      toast.success(`Added to wishlist`);
      return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, has_colors: (product.variants || []).length > 0 }];
    });
  };
  const inWish = (id) => wishlist.some((p) => p.id === id);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, wishlist, add, remove, updateQty, clear, toggleWish, inWish, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
